export function getSpelling(quantity: string | number, singular: string, exception: string, plural: string): string {
  const count = quantity.toString()
  const lastDigit = count.charAt(count.length - 1)
  const lastTwoDigits = count.substring(count.length - 2)
  const exceptions = ['11', '12', '13', '14']
  if (lastDigit === '1' && !exceptions.includes(lastTwoDigits)) {
    return `${count} ${singular}`
  }
  if ((lastDigit === '2' || lastDigit === '3' || lastDigit === '4') && !exceptions.includes(lastTwoDigits)) {
    return `${count} ${exception}`
  } else {
    return `${count} ${plural}`
  }
}
